import { useToast } from '@/hooks/useToast';
import { Toast as ToastPrimitive, ToastTitle, ToastDescription, ToastClose, ToastViewport } from '@/components/ui/toast';
import { cn } from '@/lib/utils';

export function Toaster() {
  const { toasts } = useToast();

  if (!toasts || toasts.length === 0) {
    return null;
  }

  return (
    <ToastViewport>
      {toasts.map((t) => (
        <ToastPrimitive
          key={t.id}
          duration={t.duration}
          onOpenChange={(open: boolean) => {
            if (!open) {
              // Toast auto-dismissal handled by context
            }
          }}
          className={cn(
            'group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border bg-white p-4 pr-8 shadow-lg transition-all duration-300 data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[swipe=move]:transition-none data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-left-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full',
            {
              'border-border': t.variant === 'default',
              'border-green-200 bg-green-50': t.variant === 'success',
              'border-red-200 bg-red-50': t.variant === 'error',
              'border-yellow-200 bg-yellow-50': t.variant === 'warning',
              'border-blue-200 bg-blue-50': t.variant === 'info',
            }
          )}
        >
          <div className="flex items-start gap-3 w-full">
            <div className="flex-1">
              <ToastTitle>{t.title}</ToastTitle>
              {t.description && <ToastDescription>{t.description}</ToastDescription>}
            </div>
            <ToastClose className="rounded-md p-1 text-text-muted/50 hover:text-text-muted opacity-0 group-hover:opacity-100 transition-opacity" />
          </div>
        </ToastPrimitive>
      ))}
    </ToastViewport>
  );
}
